import { FC } from "react";
import { IllustrationWrapper } from "../IllustrationWrapper";
import { IllustrationProps } from "../Illustrations.types";

const GreyBonusActivitySubscribers: FC<IllustrationProps> = (allProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IllustrationWrapper
      componentName="GreyBonusActivitySubscribers"
      illustration={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={restProps?.width ?? "24"}
          height={restProps?.height ?? "24"}
          viewBox="0 0 48 48"
          fill="none"
          {...props}
        >
          <path
            d="M47.6429 18.1014C48.9524 20.3695 48.9524 23.164 47.6429 25.4321L39.3083 39.8681C37.9987 42.1362 35.5787 43.5335 32.9596 43.5335H16.2904C13.6714 43.5335 11.2513 42.1362 9.94175 39.8681L1.60714 25.4321C0.297621 23.164 0.297621 20.3695 1.60714 18.1014L9.94175 3.66539C11.2513 1.39724 13.6714 0 16.2904 0H32.9596C35.5787 0 37.9987 1.39724 39.3082 3.66539L47.6429 18.1014Z"
            fill="#AEB4C9"
          />
          <path
            d="M43.3628 18.3027C44.4288 20.1491 44.4288 22.424 43.3628 24.2704L36.5779 36.0221C35.5119 37.8685 33.5418 39.006 31.4097 39.006H17.84C15.7079 39.006 13.7378 37.8685 12.6718 36.0221L5.88692 24.2704C4.8209 22.424 4.8209 20.1491 5.88692 18.3027L12.6718 6.55092C13.7378 4.70451 15.7079 3.56708 17.84 3.56708H31.4097C33.5418 3.56708 35.5119 4.70451 36.5779 6.55092L43.3628 18.3027Z"
            fill="black"
          />
          <path
            d="M43.3627 20.1927C44.4287 21.969 44.4287 24.1573 43.3627 25.9335L36.5778 37.2385C35.5118 39.0147 33.5417 40.1089 31.4097 40.1089H17.8399C15.7079 40.1089 13.7378 39.0147 12.6718 37.2385L5.88692 25.9335C4.8209 24.1573 4.8209 21.969 5.88692 20.1927L12.6718 8.88779C13.7378 7.11159 15.7079 6.0174 17.8399 6.0174H31.4097C33.5417 6.0174 35.5118 7.11158 36.5778 8.88779L43.3627 20.1927Z"
            fill="#AEB4C9"
          />
          <path
            d="M15.2646 8.01746C15.2646 6.91289 16.1601 6.01746 17.2646 6.01746H31.9263C33.0308 6.01746 33.9263 6.91289 33.9263 8.01746V30.5865C33.9263 31.3789 33.0486 31.8565 32.3832 31.4261L25.1376 26.7398C24.8071 26.526 24.3819 26.526 24.0514 26.7399L16.8078 31.4259C16.1425 31.8563 15.2646 31.3787 15.2646 30.5863V8.01746Z"
            fill="white"
          />
          <path
            d="M24.5957 8.46124V19.9122"
            stroke="#AEB4C9"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M17.751 6.01746V26.6411C17.751 27.0311 18.1775 27.2709 18.5107 27.0684L24.4028 23.4861C24.5631 23.3886 24.7646 23.3891 24.9244 23.4874L30.7366 27.0617C31.0698 27.2666 31.4985 27.0269 31.4985 26.6358V6.01746"
            stroke="#AEB4C9"
            strokeWidth="1.5"
          />
          <path
            d="M28.6576 34.278C28.6576 34.278 28.3831 34.1864 28.0018 34.0595C26.6865 33.621 25.6394 32.574 25.201 31.2588C25.074 30.8774 24.9824 30.6029 24.9824 30.6029C24.9269 30.4363 24.771 30.324 24.5954 30.324C24.4198 30.324 24.264 30.4363 24.2084 30.6029C24.2084 30.6029 24.1168 30.8774 23.9899 31.2587C23.5514 32.574 22.5044 33.621 21.1892 34.0594C20.8078 34.1864 20.5333 34.278 20.5333 34.278C20.3667 34.3336 20.2544 34.4895 20.2544 34.6651C20.2544 34.8406 20.3668 34.9965 20.5333 35.0521C20.5333 35.0521 20.8078 35.1436 21.1891 35.2706C22.5044 35.709 23.5514 36.756 23.9898 38.0713C24.1168 38.4526 24.2084 38.7272 24.2084 38.7272C24.264 38.8937 24.4198 39.0061 24.5954 39.0061C24.771 39.0061 24.9269 38.8937 24.9825 38.7272C24.9825 38.7272 25.0741 38.4527 25.201 38.0714C25.6395 36.7561 26.6865 35.709 28.0017 35.2706C28.3831 35.1436 28.6576 35.0521 28.6576 35.0521C28.8242 34.9965 28.9365 34.8407 28.9365 34.6651C28.9365 34.4895 28.8242 34.3336 28.6576 34.278Z"
            fill="white"
          />
        </svg>
      }
      {...restProps}
    />
  );
};

export default GreyBonusActivitySubscribers;
